/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaOtpResponse model module.
 * @module model/AqaOtpResponse
 * @version v0
 */
export default class AqaOtpResponse {
  /**
   * Constructs a new <code>AqaOtpResponse</code>.
   * @alias module:model/AqaOtpResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaOtpResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaOtpResponse} obj Optional instance to populate.
   * @return {module:model/AqaOtpResponse} The populated <code>AqaOtpResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaOtpResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('qrUrl'))
        obj.qrUrl = ApiClient.convertToType(data['qrUrl'], 'String');
      if (data.hasOwnProperty('verified'))
        obj.verified = ApiClient.convertToType(data['verified'], 'Boolean');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaOtpResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaOtpResponse.prototype.message = undefined;

/**
 * @member {String} qrUrl
 */
AqaOtpResponse.prototype.qrUrl = undefined;

/**
 * @member {Boolean} verified
 */
AqaOtpResponse.prototype.verified = undefined;

/**
 * @member {Boolean} successful
 */
AqaOtpResponse.prototype.successful = undefined;

